// src/utils/logger.ts
// Smart logging utility that respects environment settings

const isDevelopment = import.meta.env.VITE_APP_ENVIRONMENT === 'development';
const isDebugEnabled = import.meta.env.VITE_ENABLE_DEBUG === 'true';

class Logger {
  private prefix = '[heal]';

  /**
   * Standard log - only shown in development or when debug is enabled
   */
  log(...args: any[]) {
    if (isDevelopment || isDebugEnabled) {
      console.log(this.prefix, ...args);
    }
  }

  /**
   * Info log - only shown in development or when debug is enabled
   */
  info(...args: any[]) {
    if (isDevelopment || isDebugEnabled) {
      console.info(this.prefix, ...args);
    }
  }

  /**
   * Warning log - ALWAYS shown (even in production)
   */
  warn(...args: any[]) {
    console.warn(this.prefix, ...args);
  }

  /**
   * Error log - ALWAYS shown (even in production)
   */
  error(...args: any[]) {
    console.error(this.prefix, ...args);
  }

  /**
   * Debug log - only shown when VITE_ENABLE_DEBUG=true
   */
  debug(...args: any[]) {
    if (isDebugEnabled) {
      console.debug(this.prefix, '🐛', ...args);
    }
  }

  /**
   * Grouped logs - only shown in development or when debug is enabled
   */
  group(label: string) {
    if (isDevelopment || isDebugEnabled) {
      console.group(this.prefix, label);
    }
  }

  groupEnd() {
    if (isDevelopment || isDebugEnabled) {
      console.groupEnd();
    }
  }

  /**
   * Table display - only shown in development or when debug is enabled
   */
  table(data: any) {
    if (isDevelopment || isDebugEnabled) {
      console.table(data);
    }
  }
}

export const logger = new Logger();
